/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function($) {
   $("#donation-amount").keypress(function (e) {
     if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
   });

  
  $('#donation_form #next-step').on('click', function() {
    $('#donation_form [for=donation-amount]').removeClass('cb-donation-error');
    $('#donation_form .cb-donation-iban label').removeClass('cb-donation-error');

    // first step validation
    if ($('#donation_form #donation-amount').val() === '') {
      $('#donation_form [for=donation-amount]').addClass('cb-donation-error');
    } else if ($('#donation_form input[type=radio][name=payment-method]:checked').val() === 'Automatische' && $('#donation_form .cb-donation-iban input').val() === '') {
      $('#donation_form .cb-donation-iban label').addClass('cb-donation-error');
    } else {
      $(this).parents('.product-block-list__item').find('.card__collapsible-button')[0].click();
      $(this).parents('.product-block-list__item').siblings('.product-block-list__item').find('.card__collapsible-button')[0].click();
    }

    $([document.documentElement, document.body]).animate({
      scrollTop: $(this).parents('.product-block-list__item').siblings('.product-block-list__item').offset().top - 700
    }, 1000);
  });

  $('#donation_form #previous-step').on('click', function() {
    $(this).parents('.product-block-list__item').find('.card__collapsible-button')[0].click();
    $(this).parents('.product-block-list__item').siblings('.product-block-list__item').find('.card__collapsible-button')[0].click();
     $([document.documentElement, document.body]).animate({
      scrollTop: $(this).parents('.product-block-list__item').siblings('.product-block-list__item').offset().top - 200
    }, 1000);
  });

  $('#donation_form input[type=radio][name=payment-method]').change(function() {
    if (this.value == 'card') {
      $('#donation_form .cb-donation-iban').removeClass('cb-display-none');
    } else {
      $('#donation_form .cb-donation-iban').addClass('cb-display-none');
    }
  });

  $('#donation_form input[type=radio][name=frequency]').change(function() {
    if (this.value == 'monthly') {
      $('#donation_form .cb-payment-method-online').addClass('cb-display-none');
      $('#donation_form [for="automatische"]').click();
    } else {
      $('#donation_form .cb-payment-method-online').removeClass('cb-display-none');
    }
  });

  $('#donation_form').submit(function (e) {
    e.preventDefault();
    $('#donation_form button[type="submit"]').attr('disabled', 'disabled');
    
    var data = {};
    data['frequency'] = $('#donation_form input[type=radio][name=frequency]:checked').val();
    data['payment-method'] = $('#donation_form input[type=radio][name=payment-method]:checked').val();
    data['iban'] = $('#donation_form input[name=iban]').val();
    data['amount'] = $('#donation_form input[name=donation-amount]').val();
    data['donate-for'] = $('#donation_form select[name=donate-for] option:checked').val() === undefined ? $('#cb-page-title').html() : $('#donation_form select[name=donate-for] option:checked').val();
    data['sex'] = $('#donation_form input[type=radio][name=sex]:checked').val();
    data['first-name'] = $('#donation_form input[name=first-name]').val();
    data['last-name'] = $('#donation_form input[name=last-name]').val();
    data['email'] = $('#donation_form input[name=email]').val();
    data['postcode'] = $('#donation_form input[name=postcode]').val();
    data['house-number'] = $('#donation_form input[name=house-number]').val();
    data['addition'] = $('#donation_form input[name=addition]').val();
    data['street1'] = $('#donation_form input[name=street1]').val();
    data['city'] = $('#donation_form input[name=city]').val();
    data['privacy_agreement'] = $('#donation_form input[name=privacy_agreement]:checked').val() === undefined ? 'false' : 'true';
    data['receive_biography'] = $('#donation_form input[name=receive_biography]:checked').val() === undefined ? 'false' : 'true';
    data['thankyou_url'] = 'https://dpm-nederland.myshopify.com/';

    $.post('https://alt.cartblender.com/projects/dpm-nederland/create-pml.php', {data : data}, function(response) {
      $('.loader-parent .loader').removeClass('cb-display-none');
      if (response !== false && response !== 'error') {
        response = JSON.parse(response);
        window.location.href = response.redirect_url;
      } else {
        location.reload();
      }
    });
  });
  
  $(document).ready(function() {
    let searchParams = new URLSearchParams(window.location.search);

    let urlType = false;
    let urlAmount = false;
    let urlDonationFor = false;

    if (searchParams.has('type')) {
      urlType = searchParams.get('type');
    }
    if (searchParams.has('amount')) {
      urlAmount = searchParams.get('amount');
    }
    if (searchParams.has('for')) {
      urlDonationFor = searchParams.get('for');
    }

    if (urlType !== false) {
      let typeInput = $('#stap-1 .form__input-row input[aria-label="' + urlType + '"]');
      if (typeInput !== undefined) {
        let typeLable = $('#stap-1 .form__input-row label[for="' + $(typeInput).attr('id') + '"]');
        $(typeLable).click();
      }
    }

    if (urlAmount !== false) {
      $('#stap-1 #donation-amount').val(parseInt(urlAmount));
    }

    if (urlDonationFor !== false) {
      if (urlDonationFor === 'Israel') {
        urlDonationFor = 'Israël';
      }
      if (urlDonationFor === 'Zuid-Oost Azie') {
        urlDonationFor = 'Zuid-Oost Azië';
      }
      if (urlDonationFor === 'Oekraine') {
        urlDonationFor = 'Oekraïne';
      }
      if (urlDonationFor === 'Rusland') {
        urlDonationFor = 'Centraal-Azië';
      }
      $('script.dedicated-json-data').each(function (idx, el) {
        if ($(el).data('donation_for') === urlDonationFor) {
          let dedicatedJson = JSON.parse($(el).html());

          if (dedicatedJson.description !== undefined && dedicatedJson.description !== null && dedicatedJson.description !== false && dedicatedJson.description !== '') {
            $('.js-donation-description').html($(dedicatedJson.description).text());
          }
          if (dedicatedJson.image !== undefined && dedicatedJson.image !== null && dedicatedJson.image !== false && dedicatedJson.image !== '') {
            $('.js-donation-image').html(dedicatedJson.image);
          }

          $('#donation_form select[name=donate-for]').html('<option value="' + urlDonationFor + '">' + urlDonationFor + '</option>');
        }
      });
    }
  });

  // minicart add to cart upsell
  $('.cb-minicart-atc').click(function (e) {
    e.preventDefault();
    let variantId = $(this).data('var-id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: 'json', 
      success: function (data) { 
        window.location.href = '/cart';
      } 
    });
  });

  // custom quick buy button
  $('.product-form__add-button-custom-qb').click(function (e) {
    e.preventDefault();
    if ($(this).attr('disabled') !== 'disabled') {
      let variantId = $(this).data('var-id');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variantId
        },
        dataType: 'json', 
        success: function (data) { 
          window.location.href = '/cart';
        } 
      });
    }
  });
  
})(jQuery);
